(function () {
    window.KocotAnimations = window.KocotAnimations || {};

    window.KocotAnimations.initStaggerAnimations = function () {
        var items = Array.from(document.querySelectorAll('[data-anim="stagger"]'));

        if (!items.length) {
            return;
        }

        function getNumberParts(item) {
            var text = item.textContent.trim();
            var match = text.match(/^(\D*)(-?\d+(?:[.,]\d+)?)(.*)$/);

            if (!match) {
                return null;
            }

            var decimalPart = match[2].split(/[.,]/)[1];

            return {
                prefix: match[1],
                value: parseFloat(match[2].replace(',', '.')),
                suffix: match[3],
                decimals: decimalPart ? decimalPart.length : 0,
            };
        }

        function formatNumber(value, decimals) {
            if (decimals) {
                return value.toFixed(decimals).replace('.', ',');
            }

            return Math.round(value).toString();
        }

        function animateNumber(item, delay) {
            var parts = getNumberParts(item);

            if (!parts || item.dataset.countStarted === 'true') {
                return;
            }

            item.dataset.countStarted = 'true';
            item.textContent = parts.prefix + formatNumber(0, parts.decimals) + parts.suffix;

            window.setTimeout(function () {
                var start = null;
                var duration = 1500;

                function tick(timestamp) {
                    if (!start) {
                        start = timestamp;
                    }

                    var progress = Math.min((timestamp - start) / duration, 1);
                    var easedProgress = 1 - Math.pow(1 - progress, 3);
                    var currentValue = parts.value * easedProgress;

                    item.textContent = parts.prefix + formatNumber(currentValue, parts.decimals) + parts.suffix;

                    if (progress < 1) {
                        window.requestAnimationFrame(tick);
                    } else {
                        item.textContent = parts.prefix + formatNumber(parts.value, parts.decimals) + parts.suffix;
                    }
                }

                window.requestAnimationFrame(tick);
            }, delay);
        }

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            items.forEach(function (item) {
                animateNumber(item, 0);
            });

            return;
        }

        if (!('IntersectionObserver' in window)) {
            items.forEach(function (item) {
                animateNumber(item, 0);
            });

            return;
        }

        var itemObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) {
                    return;
                }

                entry.target.classList.add('is-inview');
                animateNumber(entry.target, 0);
                itemObserver.unobserve(entry.target);
            });
        }, {
            rootMargin: '0px 0px -10% 0px',
            threshold: 0,
        });

        items.forEach(function (item) {
            itemObserver.observe(item);
        });
    };
})();
